<template>
  <div class="h-dialogContainer">
    <form id='addSliceProfileForm'>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.name')}}:</div>
          <ejs-textbox name="nameCheck" v-model="name"></ejs-textbox>
        </div>

        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.serviceProfileId')}}:</div>

            <ejs-textbox
            v-model="serviceProfileName"
            name="serviceProfileIdCheck" :readonly="true"
            @focus="selectServiceProfileId" @change="validateServiceProfileIdCheck"
           ></ejs-textbox>
        </div>
      </div>

      <div class="h-borderBox h-subscriber-parseList h-dp-deploy-style">
        <div class="h-dialog-borderBox-topIcon">
          {{$t('NSMF.neDeploy')}}
          <div class="h-toolbarBg dialog-icon-style">
            <ejs-toolbar class="dialog-icon-style">
              <div class="dialog-icon-style"></div>
            </ejs-toolbar>
          </div>
        </div>
        <div class="row" id="neDeployBox">
          <div v-for="(neType, index) in neTypeList" :key="index">
           <div class="col-sm-12 h-col-inputBox" style="margin-top:10px" id="neDeployBox">
            <ejs-checkbox
              ref="neTypeCheck"
              name="neDeploy"
              :label="neType.label"
              :value="neType.value"
              :checked="neType.checked"
              :change="neTypeChangeFunc"
            ></ejs-checkbox>
           </div>
           <div :id='"amfInputNum"+neType.value' class="col-sm-6 h-col-inputBox" style="display:none;margin-top:10px">
              <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.amfDeployNum')}}:</div>
              <ejs-textbox :name='"amfNumCheck"+neType.value' v-model="amfNum" placeholder="1~6"></ejs-textbox>
            </div>
          </div>
        </div>
      </div>
      <RelateServiceProfileList ref="serviceProfileList" :getCheckedDatas="getCheckedList"></RelateServiceProfileList>
    </form>
  </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";
import RelateServiceProfileList from "./RelateServiceProfileList";

export default {
  name: "AddSliceProfile",
  components: {
    RelateServiceProfileList
  },
  data() {
    return {
      neTypeList: [
        { label: "UDM", value: "36", checked: false },
        { label: "AMF", value: "37", checked: false },
        { label: "SMF", value: "38", checked: false },
        { label: "PCF", value: "39", checked: false },
        { label: "UPF", value: "41", checked: false },
        { label: "NSSF", value: "42", checked: false },
        { label: "NRF", value: "49", checked: false },
      ],
      neMap: {
        "42": "NSSF",
        "41": "UPF",
        "39": "PCF",
        "36": "UDM",
        "37": "AMF",
        "38": "SMF",
        "49": "NRF",
      },
      neTypeArray: [],
      name: "",
      amfNum: "",
      serviceProfileId: "",
      serviceProfileName: "",
      neDeploy: [],
      neTypeName: "",
      pLMNList: "",
      sNSSAIList: "",
      locale: localStorage.getItem("locale"),
      fieldsOfGbps: {
        text: "text",
        value: "value"
      },
      formObj: "",
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          nameCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: [/^(^\S)/, `${this.$t("Topo.noEmptyStart")}`],
            maxLength: [30, `${this.$t("Topo.topoMaxLength")}30`]
          },
          serviceProfileIdCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`]
          },
          amfNumCheck37: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: ['^\\d*$', '无效的整数'],
		        range: [[1, 6], '输入值必须在1到6之间'],
          },
          
        }
      }
    };
  },
  methods: {
    getCheckedList(list) {
      if(list[0]){
      this.serviceProfileId = list[0].id;
      this.serviceProfileName = list[0].name;
      this.pLMNList = list[0].pLMNList;
      this.sNSSAIList = list[0].sNSSAIList;}
    },
    //根据任务UNM-565修改：添加change文本框值变动后检验不能为空
    validateServiceProfileIdCheck(){
      this.validate();
    },
    selectServiceProfileId() {
      this.$refs.serviceProfileList.qryList();
      this.$refs.serviceProfileList.show();
    },
    neTypeChangeFunc() {
      this.neTypeArray = this.getArray("neDeployBox");
      this.neDeploy = this.neTypeArray;
    },
    getArray(id) {
      const checkedDom = document.querySelectorAll(
        `#${id} [aria-checked=true] input`
      );
       const checkedDomUnCheck = document.querySelectorAll(
          `#${id} [aria-checked=false] input`
        );
      const array = [];
      const arrayLabel = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
        arrayLabel.push(checkedDom[i].ej2_instances[0].label);
        if(checkedDom[i].value==37){//如果选中AMF，展示部署数量
          document.getElementById("amfInputNum"+checkedDom[i].value).style.display = "block"; 
          this.formObj.addRules("amfNumCheck37",{
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: ['^\\d*$', '无效的整数'],
		        range: [[1, 6], '输入值必须在1到6之间'],
          });
        }
      }
      for (let i = 0; i < checkedDomUnCheck.length; i++) {
        if(checkedDomUnCheck[i].value==37){//如果未选中AMF，隐藏部署数量
          document.getElementById("amfInputNum"+checkedDomUnCheck[i].value).style.display = "none"; 
          this.formObj.addRules("amfNumCheck37", {
          required: [true, ``],
        });
          this.formObj.removeRules("amfNumCheck37");
        }
      }
      this.neTypeName = arrayLabel;
      return array;
    },
    clear() {
      this.name = "";
      this.amfNum = "";
      this.serviceProfileId = "";
      this.serviceProfileName = "";
      this.neDeploy = [];
    },

    loadNeForm() {
      try {
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }
    },
    getFormData() {
      if (!this.validate()) {
        return false;
      }
      let neConfigList = [];
      for (var i = 0; i < this.neDeploy.length; i++) {
        const params = {};
        params["typeCode"] = this.neDeploy[i];
        params["neType"] = this.neMap[this.neDeploy[i]];
        if( this.neDeploy[i]==37){
           params["num"] = this.amfNum;
        }
        neConfigList.push(params);
      }

      return {
        name: this.name,
        serviceProfileId: this.serviceProfileId,
        pLMNList: this.pLMNList,
        sNSSAIList: this.sNSSAIList,
        neConfig: JSON.stringify(neConfigList)
      };
    },
    bindValidate() {
      this.formObj = new FormValidator(
        "#addSliceProfileForm",
        this.validationOption
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
